define(["exports", "styled-components", "polished"], function (_exports, _styledComponents, _polished) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.GlobalStyle = void 0;
  // create a global styles
  var GlobalStyle = (0, _styledComponents.createGlobalStyle)(["", " @-ms-viewport{width:device-width;}html{box-sizing:border-box;-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;-webkit-tap-highlight-color:transparent;}*,*::before,*::after{box-sizing:inherit;font-kerning:auto;-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;}html,body{min-height:100%;-webkit-tap-highlight-color:transparent;-webkit-text-size-adjust:100%;-ms-touch-action:manipulation;touch-action:manipulation;}body{background-color:", ";color:", ";font-family:", ";font-size:", ";&.vg-no-scroll{overflow-y:hidden;}}"], (0, _polished.normalize)(), function (_ref) {
    var theme = _ref.theme;
    return theme.colors.bodyBackground;
  }, function (_ref2) {
    var theme = _ref2.theme;
    return theme.colors.textColor;
  }, function (_ref3) {
    var theme = _ref3.theme;
    return theme.font.primary;
  }, function (_ref4) {
    var theme = _ref4.theme;
    return theme.font.defaultSize;
  });
  _exports.GlobalStyle = GlobalStyle;
});